import store from "app/redux/store/store"
import * as atualizacaoItensOrcamentoLegadoActions from 'app/redux/atualizacaoItensOrcamentoLegadoSlice'
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'

declare var window: any

// Extraído de definirAliquotaItem/definirDescricaoProdutoItem/definirEntregaPosteriorItem/
// definirFilialTransferenciaItem/definirIdPontoRetiradaItem/definirOidModalidadeEntregaItem/
// definirRegimeEspecialItem/definirValorIPIItem — os 8 tinham essa função (antes chamada
// atualizarOrcamentoLegado) copiada byte a byte. Outros use-cases parecidos (ex.:
// definirTipoFaturamentoItem, definirFilialRetiradaItem) têm lógica extra no branch de
// atualização imediata e NÃO devem ser migrados para esta função sem revisar essa diferença.
export function atualizarItemNoOrcamentoLegado(orcamentoAtualizado: any, identificadorItem: number, atualizarEstadoLegadoImediatamente?: boolean) {
    const orcamentoLegado = window.orcamentoController.model

    const itemAtualizado = orcamentoAtualizado.ItensOrcamento.find(i => i.Identificador == identificadorItem)

    if (!atualizarEstadoLegadoImediatamente) {
        store.dispatch(atualizacaoItensOrcamentoLegadoActions.atualizarItem({
            identificador: itemAtualizado.Identificador,
            dadosItem: itemAtualizado
        }))
    }

    orcamentoLegado.atualizar(
        orcamentoAtualizado,
        atualizarEstadoLegadoImediatamente == true,
        true)

    if (!atualizarEstadoLegadoImediatamente) {
        store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(orcamentoAtualizado))
    }
}
